module.exports = __webpack_public_path__ + "img/img/girl-to-left.728db71d.jpg";